module.exports = __webpack_public_path__ + "static/media/Logo.56a39a4a.svg";